package dev.danko.roblox_craft_ai.pages.legal.ru

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/ru/privacy.md", FrontMatterElement.Builder { addScalar("title", "Политика конфиденциальности"); addScalar("lang", "ru"); }))
}

@Page("/legal/ru/privacy")
@Layout(".components.layouts.LegalLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("политика-конфиденциальности") }) {
        org.jetbrains.compose.web.dom.Text("Политика конфиденциальности")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Дата вступления в силу:")
        }
        org.jetbrains.compose.web.dom.Text(" 3 октября 2026 г.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Эта политика объясняет, какие персональные данные собирает сервис Craftiva AI («Сервис»), зачем, кому они передаются и какие у вас есть права. Оператор (контролёр) данных — ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME]")
        }
        org.jetbrains.compose.web.dom.Text(", [OPERATOR_STATUS], [ADDRESS], [COUNTRY]. Вопросы о данных: [SUPPORT_EMAIL].")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Юридически значимой является ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/en/privacy") {
            org.jetbrains.compose.web.dom.Text("английская версия")
        }
        org.jetbrains.compose.web.dom.Text("; русская приведена для удобства.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Мы собираем только то, что нужно для работы Сервиса. Мы не продаём персональные данные, не показываем рекламу и не используем аналитику и рекламные трекеры.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-какие-данные-мы-собираем") }) {
        org.jetbrains.compose.web.dom.Text("1. Какие данные мы собираем")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Что")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Подробности")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Зачем")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Аккаунт")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Email, время регистрации и последнего входа, тариф, статус аккаунта")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Вход и работа аккаунта")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Вход")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Одноразовые ссылки для входа (храним только хеш, действуют 15 минут, однократно); cookie входа")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Безопасный вход")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Гостевая сессия")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Случайный токен сессии в вашем браузере")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Сохранение работ без аккаунта")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Заявка на доступ")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Во время закрытого тестирования: email, имя, что вы хотите создавать, подтверждения возраста и согласия")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Рассмотрение заявок и уведомление об открытии доступа")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Ваш контент")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Запросы, изображения-примеры, созданные скрипты, модели и анимации, версии и правки")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Генерация результатов и хранение работ")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Использование и кредиты")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Какие действия вы запускаете, потраченные и купленные кредиты, оценка затрат на провайдеров")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Учёт кредитов, лимиты, защита от злоупотреблений")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Платежи")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Статус подписки, тариф, ID покупателя и подписки в Paddle. Данные карты обрабатывает Paddle, к нам они не попадают")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Привязка покупок к аккаунту")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Модерация")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Для заблокированных запросов: категория, короткий фрагмент, время и хеш сессии; ваши жалобы на результаты")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Защита от вредного контента и злоупотреблений")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Технические данные")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("IP-адрес, тип браузера, время запросов; токен, связывающий плагин Roblox Studio с вашей сессией")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Безопасность, ограничение частоты запросов, диагностика, синхронизация с плагином")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("В вашем браузере")
        }
        org.jetbrains.compose.web.dom.Text(" хранятся язык, тема, отметка о пройденном туре и локальный кэш ваших работ (localStorage и IndexedDB). Эти данные остаются на вашем устройстве.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-правовые-основания-еэз-великобритания") }) {
        org.jetbrains.compose.web.dom.Text("2. Правовые основания (ЕЭЗ/Великобритания)")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Договор")
            }
            org.jetbrains.compose.web.dom.Text(" — предоставление Сервиса, включая оплату и кредиты.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Законный интерес")
            }
            org.jetbrains.compose.web.dom.Text(" — безопасность, модерация, защита от злоупотреблений, устранение неполадок.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Требование закона")
            }
            org.jetbrains.compose.web.dom.Text(" — хранение обязательных записей.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Согласие")
            }
            org.jetbrains.compose.web.dom.Text(" — когда его требует закон, например согласие родителя для пользователей младше 16 лет в ЕЭЗ/Великобритании.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-кому-мы-передаём-данные") }) {
        org.jetbrains.compose.web.dom.Text("3. Кому мы передаём данные")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Только провайдерам, которые помогают нам работать:")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Получатель")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Зачем")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Где")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[HOSTING_PROVIDER]")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Серверы и база данных")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[HOSTING_LOCATION]")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Paddle (Paddle.com Market Ltd)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Платежи, счета и налоги как продавец (Merchant of Record); по платёжным данным Paddle — самостоятельный контролёр")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Великобритания / США")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Google (Gemini, Imagen)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Генерация скриптов, текста и концепт-изображений по вашему запросу")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("США / весь мир")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Zhipu AI (GLM)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Генерация скриптов по вашему запросу")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Китай")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("fal.ai (TRELLIS)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Генерация 3D-моделей по концепт-изображению")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("США")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Tripo3D, Meshy")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Генерация 3D-моделей (резервные провайдеры)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Китай, США")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[EMAIL_PROVIDER]")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Отправка писем со ссылкой для входа")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[EMAIL_LOCATION]")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Bunny Fonts, cdnjs (Cloudflare), jsDelivr, esm.sh")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Шрифты и библиотеки, которые загружает ваш браузер; они видят ваш IP-адрес")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("ЕС / весь мир")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Провайдеры ИИ получают содержимое запроса (текст и, для 3D, изображение), но не ваш email. Какой провайдер обработает запрос, зависит от действия и доступности. Если провайдер это позволяет, мы просим не хранить данные запроса (например, запросы в fal.ai отправляются с отключённым хранением) и выбираем варианты API, где данные не используются для обучения. Каждый провайдер обрабатывает данные по своим условиям и политике конфиденциальности.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Некоторые получатели находятся за пределами ЕЭЗ/Великобритании. Где это требуется, передача защищена, например, Стандартными договорными условиями Европейской комиссии.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Мы можем раскрыть данные, если этого требует закон или это нужно для защиты прав и безопасности пользователей и Сервиса.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-сколько-мы-храним-данные") }) {
        org.jetbrains.compose.web.dom.Text("4. Сколько мы храним данные")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Данные аккаунта и ваши работы — пока вы не удалите работу или аккаунт.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Эскизы, по которым не создали 3D-модель, — 30 дней.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Детальная (исходная) версия 3D-модели от генератора — 30 дней после создания; версия для Roblox хранится вместе с работой.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ссылки для входа — 15 минут; cookie входа — 30 дней.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Записи об использовании, кредитах и платежах — до 3 лет после операции, дольше только если этого требует закон. Записи о купленных кредитах хранятся, пока существует аккаунт: из них складывается баланс.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Заявки на доступ — отклонённые удаляются через 6 месяцев; одобренная заявка становится частью аккаунта.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Записи модерации — до 12 месяцев.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Логи сервера — до 30 дней.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Резервные копии — до 14 дней.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("При удалении аккаунта сразу удаляются аккаунт, работы и файлы. Записи об использовании и кредитах остаются для учёта, но больше никак не связаны с вами.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-дети") }) {
        org.jetbrains.compose.web.dom.Text("5. Дети")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Сервис не предназначен для детей младше 13 лет. Дети младше 13 лет могут пользоваться им только вместе с родителем через аккаунт родителя. В ЕЭЗ/Великобритании пользователям младше 16 лет нужно согласие родителя. Совершать покупки могут только взрослые. Если вы считаете, что ребёнок младше 13 лет передал нам данные без участия родителя, напишите нам — мы их удалим.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("6-cookie") }) {
        org.jetbrains.compose.web.dom.Text("6. Cookie")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Мы используем одну необходимую cookie — ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("rc_auth")
        }
        org.jetbrains.compose.web.dom.Text(", она сохраняет вход (HttpOnly, 30 дней). Аналитических и рекламных cookie нет, поэтому баннер о cookie не нужен. При оплате страница Paddle может устанавливать свои cookie по политике Paddle.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("7-безопасность") }) {
        org.jetbrains.compose.web.dom.Text("7. Безопасность")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Соединения шифруются (HTTPS). Ссылки для входа хранятся только в виде хешей. API-ключи, сохранённые в Сервисе, зашифрованы (AES-256-GCM). Доступ к инструментам администрирования есть только у уполномоченных администраторов.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("8-ваши-права") }) {
        org.jetbrains.compose.web.dom.Text("8. Ваши права")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("В зависимости от страны проживания вы можете запросить доступ к своим данным, их исправление, удаление или выгрузку, ограничить обработку или возразить против неё, отозвать согласие. В разделе ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Настройки → Аккаунт")
        }
        org.jetbrains.compose.web.dom.Text(" вы в любой момент можете сами скачать все свои данные и удалить аккаунт. По остальным вопросам напишите на [SUPPORT_EMAIL] с email вашего аккаунта — мы ответим в течение 30 дней. Вы также можете подать жалобу в орган по защите данных своей страны.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("9-изменения") }) {
        org.jetbrains.compose.web.dom.Text("9. Изменения")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Мы можем обновлять эту политику. О существенных изменениях сообщим на сайте или по email до того, как они вступят в силу.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("10-контакты") }) {
        org.jetbrains.compose.web.dom.Text("10. Контакты")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME], [ADDRESS], [COUNTRY] · [SUPPORT_EMAIL]")
    }
}
